import CommentListView from 'backbone/story/views/comments/comment_list_view.js'
import CommentFormView from 'backbone/story/views/comments/comment_form_view.js'
import GoogleAnalyticsTracker from 'utils/shared/google_analytics_tracker.js'

export default class TabPanelsView extends Backbone.View
  events:
    "click .nav-meta a"           : "onTabClick"
    "click .js-show-comment-form" : "showCommentForm"

  initialize: (options) ->
    @resourceType = options.resourceType
    @resourceId = options.resourceId

    @$composeWrapper = @$(".panel-content-wrapper .media.panel")
    @$metaWrapper = @$("#meta-wrapper")
    @$panelWrapper = @$(".panel-wrapper")
    @$panels = @$("#meta-wrapper article")
    @$tabs = @$(".nav-meta.desktop li")
    @$tabsMobile = @$(".nav-meta.mobile li")
    @$composeTab = @$("a.compose").parent("li")
    @$showCommentFormButton = @$(".js-show-comment-form")

    initialPanel = window.location.hash.substr(1)
    @activatePanel(initialPanel) if @validPanelName(initialPanel)

    if @resourceType == "pitch" && @$panels.filter(".comments").is(":visible")
      @loadPanel("comments")

  onTabClick: (event) ->
    event.preventDefault()
    $link = $(event.currentTarget)
    panelName = $link.attr("href").substr(1)

    if $link.closest("li").hasClass("active")
      @$panelWrapper.addClass("hide-meta")
      @$tabs.removeClass("active js-prevent-tooltip")
      page.get("stickyHeaderView").slidePanelChange()

    else
      if @$panelWrapper.hasClass("hide-meta")
        @$panelWrapper.removeClass("hide-meta")
        page.get("stickyHeaderView").slidePanelChange()

      @activatePanel panelName
      contently.ui.autosizeTextarea(@$el)

    contently.ui.closeTooltip(@$el)

  activateMainPanel: ->
    @$composeWrapper.removeClass("inactive")
    @$metaWrapper.removeClass("active")
    @$tabsMobile.removeClass("active")
    @$composeTab.addClass("active")
    $(".toolbar").resize()

  activatePanel: (panelName) ->
    if @validPanelName(panelName)
      @$composeWrapper.addClass("inactive")
      @$metaWrapper.addClass("active")
      @$panels.removeClass("active").filter(".#{panelName}").addClass("active")
      @$tabs
        .removeClass("active js-prevent-tooltip")
        .find("a.#{panelName}").removeClass("notification")
        .parent("li").addClass("active js-prevent-tooltip")
      @$tabsMobile
        .removeClass("active")
        .find("a.#{panelName}").parent("li").addClass("active")
      @fireGoogleAnalyticsPageEvent(panelName)
      @loadPanel(panelName) unless @panelLoaded(panelName)
    else if panelName == "" || panelName == "compose"
      @activateMainPanel()

  validPanelName: (panelName) ->
    panelName in @validPanelNames()

  validPanelNames: ->
    $(panel).data("panelName") for panel in @$panels

  panelLoaded: (panelName) ->
    panelName in @loadedPanelNames()

  loadedPanelNames: ->
    ($(panel).data("panelName") for panel in @$panels when $(panel).data('loaded') == true)

  getPanelByName: (panelName) ->
    $(@$panels.filter("[data-panel-name='#{panelName}']"))

  getPanelUrlByName: (panelName, $panel) ->
    return $panel.data("load-endpoint") if $panel.data("load-endpoint")

    base =
    switch @resourceType
     when "story" then "stories"
     when "pitch" then "pitches"
    "/#{base}/#{@resourceId}/#{panelName}"

  loadPanel: (panelName) ->
    $panel = @$panels.filter(".#{panelName}")
    if $panel.is(":visible")
      $maskable = $panel.maskLoading()

    @getPanelByName(panelName).data("loaded", true)

    if panelName == "comments" && @resourceType == "story"
      @loadCommentsPanel()
    else if @resourceType == "content_request"
      $maskable.unmaskLoading() if $maskable
    else
      $.ajax(
        type: "GET",
        url: @getPanelUrlByName(panelName, $panel)
        dataType: "script"
      ).always(=>
        if panelName is "comments"
          contently.ui.autosizeTextarea($panel)
        contently.ui.setup_select2($panel)
        $maskable.unmaskLoading() if $maskable
      )

  loadCommentsPanel: ->
    @commentListView = new CommentListView()
    @$el.find("article.comments").append @commentListView.render().$el
    contently.ui.autosizeTextarea(@$el)

  fireGoogleAnalyticsPageEvent: (page) ->
    ga_page = switch page
      when "requirements" then "details"
      when "comments" then "comments"
      when "assets" then "attachments"
      when "activity" then "history"
      when "style-guide" then "style-guide"
      else page

    GoogleAnalyticsTracker.page_event "view assignment #{ga_page}"

  showCommentForm: ->
    @commentFormView = new CommentFormView(
      onDestroy: @showCreateCommentButton
      targeted: false
    )

    @$(".js-comment-form").append(@commentFormView.el)
    @$showCommentFormButton.hide()
    contently.ui.autosizeTextarea(@commentFormView.el)

  showCreateCommentButton: => @$showCommentFormButton.show()



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/tab_panels_view.js.coffee